<template>
  <div class="risk-shell">
    <div class="risk-banner">
      <span class="left">{{ meta.banner }}</span>
      <span class="right">{{ meta.disclaimer }}</span>
    </div>

    <div class="risk-controls">
      <el-select :value="meta.observeMode" size="mini" class="ctl" disabled>
        <el-option :label="meta.observeMode" :value="meta.observeMode" />
      </el-select>
      <div class="date-readonly">
        <span class="lbl">观察日期</span>
        <span class="val">{{ tradeDate || '—' }}</span>
        <span class="hint">（与顶栏日期同步）</span>
      </div>
      <span class="meta-chip">观察截止 {{ meta.observeCutoff }}</span>
      <el-select :value="meta.acceptanceNote" size="mini" class="ctl wide" disabled>
        <el-option :label="meta.acceptanceNote" :value="meta.acceptanceNote" />
      </el-select>
      <el-select :value="meta.dataStatus" size="mini" class="ctl" disabled>
        <el-option :label="meta.dataStatus" :value="meta.dataStatus" />
      </el-select>
    </div>

    <div v-if="loadError" class="empty">{{ loadError }}</div>
    <div v-else class="risk-grid">
      <RiskLeaderList
        :leaders="leaders"
        :selected-id="selectedId"
        :loading="loading"
        @select="onSelect"
      />
      <RiskCenterPanel
        :leader="selectedLeader"
        :leader-index="selectedIndex"
      />
      <RiskSidePanel :catchup-rows="selectedCatchupRows" />
    </div>
  </div>
</template>

<script>
import riskDemo from '@/data/leaderCommandCenter/riskModeDemo.json'
import RiskLeaderList from './RiskLeaderList.vue'
import RiskCenterPanel from './RiskCenterPanel.vue'
import RiskSidePanel from './RiskSidePanel.vue'

export default {
  name: 'RiskModeShell',
  components: { RiskLeaderList, RiskCenterPanel, RiskSidePanel },
  props: {
    tradeDate: { type: String, default: '' },
    leaders: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    loadError: { type: String, default: '' },
    catchupRowsFor: { type: Function, default: null }
  },
  data() {
    return {
      selectedId: ''
    }
  },
  computed: {
    meta() {
      return riskDemo.meta || {}
    },
    selectedLeader() {
      const list = this.leaders || []
      if (!list.length) return null
      const found = list.find((l) => (l.leaderId || l.code) === this.selectedId)
      return found || list[0]
    },
    selectedIndex() {
      const list = this.leaders || []
      const cur = this.selectedLeader
      if (!cur) return 0
      const id = cur.leaderId || cur.code
      const i = list.findIndex((l) => (l.leaderId || l.code) === id)
      return i < 0 ? 0 : i
    },
    selectedCatchupRows() {
      if (typeof this.catchupRowsFor !== 'function' || !this.selectedLeader) return []
      try {
        return this.catchupRowsFor(this.selectedLeader) || []
      } catch (e) {
        return []
      }
    }
  },
  watch: {
    leaders: {
      immediate: true,
      handler(list) {
        const rows = list || []
        if (!rows.length) {
          this.selectedId = ''
          return
        }
        const still = rows.some((l) => (l.leaderId || l.code) === this.selectedId)
        if (!still) {
          this.selectedId = rows[0].leaderId || rows[0].code || ''
        }
      }
    }
  },
  methods: {
    onSelect(row) {
      this.selectedId = (row && (row.leaderId || row.code)) || ''
    }
  }
}
</script>

<style scoped lang="scss">
.risk-shell {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: calc(100vh - 220px);
}
.risk-banner {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  background: #eef6ff;
  color: #1a4f8b;
  border: 1px solid #cfe0f8;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 12px;
}
.risk-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  background: #fff;
  border: 1px solid #d7e4f6;
  border-radius: 10px;
  padding: 8px 10px;
}
.ctl {
  width: 120px;
  &.wide { width: 280px; max-width: 100%; }
}
.date-readonly {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #d7e4f6;
  border-radius: 6px;
  background: #f7faff;
  font-size: 12px;
  .lbl { color: #90a4c0; }
  .val { color: #1a73e8; font-weight: 700; }
  .hint { color: #b0c0d8; font-size: 11px; }
}
.meta-chip {
  font-size: 12px;
  color: #5b6b82;
  padding: 4px 8px;
}
.risk-grid {
  flex: 1;
  min-height: 520px;
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr) 280px;
  gap: 10px;
  align-items: stretch;
}
.empty {
  padding: 32px;
  text-align: center;
  color: #90a4c0;
  background: #fff;
  border: 1px solid #d7e4f6;
  border-radius: 12px;
}
@media (max-width: 1280px) {
  .risk-grid {
    grid-template-columns: 260px minmax(0, 1fr);
  }
  .risk-grid > :last-child {
    grid-column: 1 / -1;
  }
}
</style>
